import $ from "jquery";
import "slick-carousel";
import AOS from "aos";
import lozad from "lozad";

$(function () {
	"use strict";

	// $( "<div class='grid-container' style='position: relative;'>Test</div>" ).insertAfter( "#ImageGallery" );

	// Slick sliders
	$(".RelatedResourcesCarousel").on("init", function (event, slick) {
		AOS.init();
		const observer = lozad(); // lazy loads elements with default selector as ".lozad"
		observer.observe();
	});
	$(".RelatedResourcesCarousel").slick({
		centerMode: true,
		arrows: true,
		dots: false,
		infinite: true,
		variableWidth: true,
		slidesToShow: 1,
		rows: 0,
		responsive: [
			{
				breakpoint: 924,
				settings: {
					slidesToShow: 1,
					arrows: true,
					infinite: true,
					variableWidth: true,
				}
			}
		]
	});


});


import "../../node_modules/slick-carousel/slick/slick.css";
import "../../node_modules/slick-carousel/slick/slick-theme.css";
